@if (debug) {
  <details class="advanced">
    <summary><span i18n>Debug</span> @if (batchRunning()) { <app-loading /> }</summary>
    <a class="fake-link" (click)="settingUser.update(v => !v)">user</a>
    @if (settingUser()) {
      <span>
        <input #inlineUser
               i18n-placeholder placeholder="bob"
               (keydown)="$event.key === 'Enter' && setUser(inlineUser.value || 'bob') || true">
        <button type="button" (click)="setUser(inlineUser.value || 'bob')">⏎</button>
      </span>
    }
    <a class="fake-link" (click)="generating.set(!generating())">gen</a>
    @if (generating()) {
      <span>
        <input #inlineGen
               value="100"
               (keydown)="$event.key === 'Enter' && gen(inlineGen.value) || true"
               type="number">
        <button type="button" (click)="gen(inlineGen.value)">⏎</button>
      </span>
    }
    @if (!empty()) {
      <a class="fake-link" (click)="sourcing.set(!sourcing())">source</a>
      @if (sourcing()) {
        <span>
          <input #inlineUrl
                 placeholder="url"
                 (keydown)="$event.key === 'Enter' && source(inlineUrl.value) || true"
                 type="url">
          <button type="button" (click)="source(inlineUrl.value)">⏎</button>
        </span>
      }
    }
    @for (e of serverError(); track e) {
      <div class="error">{{ e }}</div>
    }
  </details>
}
